<template>
  <div class="popup_wrap" style="width:1500px;">
    <button type="button" class="layer_close" @click="layerClose()">close</button>
    <div class="popup_cont">
      <h1 class="page_title">{{ $t('msg.COUP100.056') }}</h1>
      <div class="content_box">
        <table>
          <colgroup>
            <col width="300px">
            <col width="1100px">
          </colgroup>
          <tbody>
            <tr>
              <td>
                <div class="content_box mt10" style="width:400px;">
                  <div id="realgrid3" style="width: 100%; height: 500px" />
                </div>
              </td>
              <td>
                <div class="content_box mt10" style="width:1020px;">
                  <div id="realgrid2" style="width: 100%; height: 500px" />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="mt10 text_center">
        <a class="button blue lg" href="#" @click.prevent="saveApplyCoupon();">{{ $t('msg.COUP100.059') }}</a>
        <a class="button blue lg" href="#" @click.prevent="layerClose();">{{ $t('msg.COUP100.060') }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import { rootComputed } from '@/store/helpers'
import { createGrid } from '@/plugins/realgridUtil'
import schedule from '@/api/rest/schedule/schedule'
import CalcIssue from '@/api/rest/settle/calcIssue'

let gridView = null
let provider = null

let gridView2 = null
let provider2 = null

const fields = [
  { fieldName: 'blNo', dataType: 'text' },
  { fieldName: 'porCtrCd', dataType: 'text' },
  { fieldName: 'porPlcCd', dataType: 'text' },
  { fieldName: 'dlyCtrCd', dataType: 'text' },
  { fieldName: 'dlyPlcCd', dataType: 'text' },
  { fieldName: 'cntrTypCd', dataType: 'text' },
  { fieldName: 'qty20', dataType: 'text' },
  { fieldName: 'qty40', dataType: 'text' },
  { fieldName: 'couponNo', dataType: 'text' },
  { fieldName: 'couponUse', dataType: 'text' },
  { fieldName: 'saleAmt', dataType: 'text' }
]
const columns = [
  { name: 'blNo', fieldName: 'blNo', header: { text: 'BL.NO' }, editable: false, width: 50 },
  { name: 'porCtrCd', fieldName: 'porCtrCd', visible: false, header: { text: 'POR' }, editable: false, width: 50 },
  { name: 'porPlcCd', fieldName: 'porPlcCd', visible: false, header: { text: 'POR' }, editable: false, width: 50 },
  { name: 'dlyCtrCd', fieldName: 'dlyCtrCd', visible: false, header: { text: 'DLY' }, editable: false, width: 50 },
  { name: 'dlyPlcCd', fieldName: 'dlyPlcCd', visible: false, header: { text: 'DLY' }, editable: false, width: 50 },
  { name: 'cntrTypCd', fieldName: 'cntrTypCd', visible: false, header: { text: 'CNTR' }, editable: false, width: 50 },
  { name: 'couponNo', fieldName: 'couponNo', visible: false, header: { text: app.$t('msg.COUP100.096') }, editable: false, width: 50 }, // 쿠폰번호
  { name: 'couponUse', fieldName: 'couponUse', header: { text: app.$t('msg.COUP100.052') }, editable: false, width: 50 },
  { name: 'saleAmt', fieldName: 'saleAmt', header: { text: app.$t('msg.COUP100.053') }, editable: false, width: 50 }
]

const fields2 = [
  { fieldName: 'porCtrCd', dataType: 'text' }, // 출항지 국가 코드
  { fieldName: 'porCtrNm', dataType: 'text' }, // 출항지 국가 명
  { fieldName: 'porPlcCd', dataType: 'text' }, // 출항지 지역
  { fieldName: 'dlyCtrCd', dataType: 'text' }, // 도착지 국가 코드
  { fieldName: 'dlyCtrNm', dataType: 'text' }, // 도착지 국가 명
  { fieldName: 'dlyPlcCd', dataType: 'text' }, // 도착지 지역
  { fieldName: 'strDt', dataType: 'datetime', datetimeFormat: 'yyyyMMdd' }, // 시작일
  { fieldName: 'endDt', dataType: 'datetime', datetimeFormat: 'yyyyMMdd' }, // 만료일
  { fieldName: 'cntrTypCd', dataType: 'text' }, // CNTR TYPE
  { fieldName: 'of20Rate', dataType: 'text' }, // 20 DC 금액
  { fieldName: 'of40Rate', dataType: 'text' }, // 40 DC 금액
  { fieldName: 'couponNo', dataType: 'text' },
  { fieldName: 'useBtn', dataType: 'text' },
  { fieldName: 'couponNm', dataType: 'text' },
  { fieldName: 'couponTyp', dataType: 'text' },
  { fieldName: 'dcRate20', dataType: 'text' }, // 경량화물 20 DC 금액
  { fieldName: 'dcRate40', dataType: 'text' }, // 경량화물 40 DC 금액
  { fieldName: 'applied', dataType: 'boolean' } // 클릭 여부 체크용 필드 추가
  // { fieldName: 'coupon', dataType: 'text' }
]
const columns2 = [
  { name: 'couponNm', fieldName: 'couponNm', header: { text: app.$t('msg.COUP100.039') }, editable: false, width: 20 },
  {
    name: 'couponTyp',
    fieldName: 'couponTyp',
    header: { text: app.$t('msg.COUP100.020') }, // 쿠폰타입
    editable: false,
    width: 15,
    renderer: {
        type: 'html',
        callback: function (grid, cell, w, h) {
          const idx = cell.index.dataRow
          const couponTyp = vmAppWpx.list[idx].couponTyp || ''

          if (couponTyp === '01') {
            return app.$t('msg.COUP100.022') // 할인쿠폰
          } else if (couponTyp === '02') {
            return app.$t('msg.COUP100.023') // 누적할인쿠폰
          } else if (couponTyp === '05') {
            return app.$t('msg.COUP100.101') //경량화물
          } else if (couponTyp === '04') {
            return app.$t('msg.COUP100.099') // 조기부킹
          }
        }
    }
  },
  {
    name: 'couponTyp',
    fieldName: 'couponTyp',
    header: { text: app.$t('msg.COUP100.100') }, // 부가혜택
    editable: false,
    width: 15,
    renderer: {
        type: 'html',
        callback: function (grid, cell, w, h) {
          const idx = cell.index.dataRow
          const couponTyp = vmAppWpx.list[idx].couponTyp || ''

          if (couponTyp === '04') {
            return app.$t('msg.COUP100.097')
          } else {
            return '-'
          }
        }
    }
  },
  { name: 'porCtrNm', fieldName: 'porCtrNm', header: { text: app.$t('msg.COUP100.003') }, editable: false, width: 15 },
  { name: 'porPlcCd', fieldName: 'porPlcCd', header: { text: app.$t('msg.COUP100.006') }, visible: false, editable: false, width: 10 },
  { name: 'dlyCtrNm', fieldName: 'dlyCtrNm', header: { text: app.$t('msg.COUP100.004') }, editable: false, width: 15 },
  { name: 'dlyPlcCd', fieldName: 'dlyPlcCd', header: { text: app.$t('msg.COUP100.006') }, visible: false, editable: false, width: 10 },
  { name: 'strDt', fieldName: 'strDt', header: { text: app.$t('msg.COUP100.007') }, editable: false, width: 15 },
  { name: 'endDt', fieldName: 'endDt', header: { text: app.$t('msg.COUP100.008') }, editable: false, width: 15 },
  { name: 'cntrTypCd', fieldName: 'cntrTypCd', header: { text: app.$t('msg.COUP100.009') }, editable: false, width: 13 },
  {
    name: 'of20Rate',
    fieldName: 'of20Rate',
    header: { text: app.$t('msg.COUP100.011') },
    editable: false,
    width: 7,
    renderer: {
      type: 'html',
      callback: function (grid, cell, w, h) {
        const idx = cell.index.dataRow
        const couponTyp = vmAppWpx.list[idx].couponTyp || ''
        const of20Rate = vmAppWpx.list[idx].of20Rate || ''
        const dcRate20 = vmAppWpx.list[idx].dcRate20 || ''

        if (couponTyp === '05') {
          return dcRate20
        } else {
          return of20Rate
        }
      }
    }
  },
  {
    name: 'of40Rate',
    fieldName: 'of40Rate',
    header: { text: app.$t('msg.COUP100.012') },
    editable: false,
    width: 7,
    renderer: {
      type: 'html',
      callback: function (grid, cell, w, h) {
        const idx = cell.index.dataRow
        const couponTyp = vmAppWpx.list[idx].couponTyp || ''
        const of40Rate = vmAppWpx.list[idx].of40Rate || ''
        const dcRate40 = vmAppWpx.list[idx].dcRate40 || ''

        if (couponTyp === '05') {
          return dcRate40
        } else {
          return of40Rate
        }
      }
    }
  },
  { name: 'couponNo', fieldName: 'couponNo', visible: false, header: { text: app.$t('msg.COUP100.093') }, editable: false, width: 50 },
  {
    name: 'useBtn',
    fieldName: 'useBtn',
    type: 'text',
    width: '10',
    header: { text: ' ' },
    editable: false,
    renderer: {
      type: 'html',
      callback: function (grid, cell, w, h) {
        const idx = cell.index.dataRow
        const couponTyp = vmAppWpx.list[idx].couponTyp || ''
        const isApplied = grid.getDataSource().getValue(idx, 'applied')

        if (isApplied === true || couponTyp === '04' || couponTyp === '05') {
            return app.$t('msg.COUP100.095') // '적용완료'
        } else {
            return `<span class="yes"><a class="button sm" onclick="vmAppWpx.couponAply('${idx}');">${app.$t('msg.COUP100.058')}</a></span>`
        }
      }
    }
  }
]

export default {
  name: 'KmtcCouponPop',
  props: {
    parentInfo: {
        type: Object,
        default: function () {
            return {}
        }
    }
  },
  data () {
    return {
      mainIdx: 0,
      items: [],
      main: [],
      clickedRowIndex: -1,
      subParam: {
        blNo: '',
        porCtrCd: '',
        porPlcCd: '',
        dlyCtrCd: '',
        dlyPlcCd: '',
        cntrTyp: ''
      },
      list: []
    }
  },
  computed: {
    ...rootComputed,
    isEkmtc () {
      return sessionStorage.getItem('loginId').indexOf('EKMTC_') !== -1
    }
  },
  async mounted () {
    const $vm = this
    window.vmAppWpx = this

    const grid = createGrid('realgrid3', {
      fields,
      columns,
      header: {
        heights: [30]
      },
      displayOptions: {
        rowHeight: 34,
        fitStyle: 'even',
        selectionStyle: 'rows'
      },
      stateBar: {
        visible: false
      },
      checkBar: {
        visible: false
      },
      rowIndicator: {
        visible: false
      },
      sortingOptions: {
        keepFocusedRow: true,
        style: 'inclusive',
        showSortOrder: true
      }
    })
    gridView = grid.gridView
    provider = grid.provider
    gridView.footers.visible = false

    const grid2 = createGrid('realgrid2', {
      fields: fields2,
      columns: columns2,
      header: {
        heights: [30]
      },
      displayOptions: {
        rowHeight: 34,
        fitStyle: 'even',
        selectionStyle: 'rows'
      },
      stateBar: {
        visible: false
      },
      checkBar: {
        visible: false
      },
      rowIndicator: {
        visible: false
      },
      sortingOptions: {
        keepFocusedRow: true,
        style: 'inclusive',
        showSortOrder: true
      }
    })
    gridView2 = grid2.gridView
    provider2 = grid2.provider
    gridView2.footers.visible = false

    gridView.onCellClicked = async (_grid, clickData) => {
      if (clickData.cellType === 'data') {
        const currentRow = clickData.dataRow
        const existingAmt = provider.getValue(currentRow, 'saleAmt')

        $vm.clickedRowIndex = clickData.dataRow
        _grid.refresh()

        $vm.getGridInfo(clickData.dataRow)
        await $vm.subSelect()

        if (!$vm.$ekmtcCommon.isNotEmpty(existingAmt)) {
          // 값이 없을 때만 최초 1회 자동 계산 실행
            $vm.couponSum(currentRow)
        }
      }
    }

    gridView.setRowStyleCallback(function (grid, item, fixed) {
      var ret = {}
      var dataRow = item.dataRow
      var cntrTypCd = grid.getValue(item.index, 'cntrTypCd')

      // 클릭된 행 스타일 (최우선순위)
      if (dataRow === $vm.clickedRowIndex && $vm.clickedRowIndex !== -1) {
        return {
          style: {
            background: '#dbeafe' // 클릭했을 때 파란색
          }
        }
      }

      if (cntrTypCd === 'N') {
        ret.style = { background: '#CED8F6' }
      }
      return ret
    })

    provider.setRows(this.$props.parentInfo.items)
    this.main = this.$props.parentInfo.items
    await $vm.autoApplyBestCoupons()
  },
  methods: {
    async layerClose () {
      if (await this.$ekmtcCommon.asyncAlertMessage({ message: this.$t('msg.COUP100.104'), useConfirmBtn: true })) {
        this.$emit('close', 'cancel')
      }
    },
    parseCouponAmt (rate) {
      if (rate == null || rate === '') {
        return 0
      }
      const s = String(rate).replace(/,/g, '').trim()
      if (s === '') {
        return 0
      }
      if (s.indexOf('%') >= 0) {
        return null
      }
      const n = Number(s)
      return isNaN(n) ? null : n
    },
    couponBenefit (item) {
      const qty20 = Number(provider.getValue(this.mainIdx, 'qty20') || 0)
      const qty40 = Number(provider.getValue(this.mainIdx, 'qty40') || 0)
      let of20
      let of40
      if (item.couponTyp === '05') {
        of20 = this.parseCouponAmt(item.dcRate20)
        of40 = this.parseCouponAmt(item.dcRate40)
      } else {
        of20 = this.parseCouponAmt(item.of20Rate)
        of40 = this.parseCouponAmt(item.of40Rate)
      }
      if (of20 == null || of40 == null) {
        return 0
      }
      return (of20 * qty20) + (of40 * qty40)
    },
    pickBestCouponIndex () {
      let bestIdx = null
      let bestAmt = 0
      let bestTyp = '99'
      let bestStrDt = ''

      for (let i = 0; i < this.list.length; i++) {
        const typ = this.list[i].couponTyp || ''
        if (typ !== '01' && typ !== '02') {
          continue
        }
        const of20 = this.parseCouponAmt(this.list[i].of20Rate)
        const of40 = this.parseCouponAmt(this.list[i].of40Rate)
        if (of20 == null || of40 == null) {
          continue
        }
        const benefit = this.couponBenefit(this.list[i])
        if (benefit <= 0) {
          continue
        }
        const strDt = String(this.list[i].strDt || '')
        const better =
          bestIdx == null ||
          benefit > bestAmt ||
          (benefit === bestAmt && typ === '01' && bestTyp !== '01') ||
          (benefit === bestAmt && typ === bestTyp && strDt > bestStrDt)
        if (better) {
          bestIdx = i
          bestAmt = benefit
          bestTyp = typ
          bestStrDt = strDt
        }
      }
      return bestIdx
    },
    async autoApplyBestCoupons () {
      const rowCount = provider.getRowCount()
      let appliedCnt = 0
      let maxChoiceCnt = 0
      const unavailable = this.$t('msg.COUP100.057')

      for (let i = 0; i < rowCount; i++) {
        if (provider.getValue(i, 'couponUse') === unavailable) {
          continue
        }
        this.getGridInfo(i)
        const loaded = await this.subSelect()
        if (!loaded) {
          // 조회 실패 시 this.list 가 직전 B/L 목록으로 남아 엉뚱한 쿠폰이 적용된다
          continue
        }
        const existingAmt = provider.getValue(i, 'saleAmt')
        if (!this.$ekmtcCommon.isNotEmpty(existingAmt)) {
          this.couponSum(i)
        }
        const choiceCnt = this.list.filter(item => item.couponTyp === '01' || item.couponTyp === '02').length
        if (choiceCnt > maxChoiceCnt) {
          maxChoiceCnt = choiceCnt
        }
        const bestIdx = this.pickBestCouponIndex()
        if (bestIdx != null) {
          this.couponAply(bestIdx)
          appliedCnt += 1
        }
      }

      this.clickedRowIndex = 0
      if (rowCount > 0) {
        this.getGridInfo(0)
        await this.subSelect()
        gridView.setCurrent({ itemIndex: 0 })
        gridView.refresh()
        if (gridView2) {
          gridView2.refresh()
        }
      }

      if (appliedCnt > 0) {
        const msgKey = maxChoiceCnt > 1 ? 'msg.COUP100.102' : 'msg.COUP100.103'
        await this.$ekmtcCommon.asyncAlertMessage({ message: this.$t(msgKey) })
      }
    },
    couponAply (idx) {
      const couponTyp = this.list[idx] ? this.list[idx].couponTyp || '' : ''
      const qty20 = Number(provider.getValue(this.mainIdx, 'qty20') || 0)
      const qty40 = Number(provider.getValue(this.mainIdx, 'qty40') || 0)

      // 할인쿠폰(01) 또는 누적할인쿠폰(02) 적용 시, 이미 적용된 01/02 쿠폰 해제
      if (couponTyp === '01' || couponTyp === '02') {
        this.list.forEach((item, i) => {
          if (i !== Number(idx) && (item.couponTyp === '01' || item.couponTyp === '02') && provider2.getValue(i, 'applied') === true) {
            const prev20 = this.parseCouponAmt(provider2.getValue(i, 'of20Rate')) || 0
            const prev40 = this.parseCouponAmt(provider2.getValue(i, 'of40Rate')) || 0
            const prevAmt = (prev20 * qty20) + (prev40 * qty40)
            const orgSum = provider.getValue(this.mainIdx, 'saleAmt')
            if (this.$ekmtcCommon.isNotEmpty(orgSum)) {
              const newSum = Number(orgSum.substring(2)) - prevAmt
              provider.setValue(this.mainIdx, 'saleAmt', '-$' + newSum)
            }
            provider2.setValue(i, 'applied', false)
          }
        })
        gridView2.refresh()
      }

      provider.setValue(this.mainIdx, 'couponNo', provider2.getValue(idx, 'couponNo'))
      provider.setValue(this.mainIdx, 'couponUse', this.$t('msg.COUP100.056'))

      const of20 = this.parseCouponAmt(provider2.getValue(idx, 'of20Rate')) || 0
      const of40 = this.parseCouponAmt(provider2.getValue(idx, 'of40Rate')) || 0
      let saleAmt = (of20 * qty20) + (of40 * qty40)
      let orgSum = provider.getValue(this.mainIdx, 'saleAmt')

      if (this.$ekmtcCommon.isNotEmpty(orgSum)) {
        orgSum = Number(orgSum.substring(2))
        saleAmt += orgSum
      }

      provider.setValue(this.mainIdx, 'saleAmt', '-$' + saleAmt)

      provider2.setValue(idx, 'applied', true)
    },
    couponSum (idx) {
      const list = this.list
      let sum = 0
      let qty20 = this.$props.parentInfo.items[idx].qty20
      let qty40 = this.$props.parentInfo.items[idx].qty40

      // if (!this.list || this.list.length === 0) {
      //   return
      // }

      let dcRate20
      let dcRate40

      list.forEach(item => {
        if (item.couponTyp === '05' || item.couponTyp === '04') {
          if (item.couponTyp === '05') { // 경량화물
            dcRate20 = item.dcRate20 || 0
            dcRate40 = item.dcRate40 || 0
          } else {
            dcRate20 = item.of20Rate || 0
            dcRate40 = item.of40Rate || 0
          }

          sum += Number((dcRate20 * qty20)) + Number((dcRate40 * qty40))
        }
      })

      provider.setValue(idx, 'saleAmt', '-$' + sum)
    },
    getGridInfo (idx) {
        this.subParam.blNo = this.$props.parentInfo.items[idx].blNo
        this.subParam.porCtrCd = this.$props.parentInfo.items[idx].porCtrCd
        this.subParam.porPlcCd = this.$props.parentInfo.items[idx].porPlcCd
        this.subParam.dlyCtrCd = this.$props.parentInfo.items[idx].dlyCtrCd
        this.subParam.dlyPlcCd = this.$props.parentInfo.items[idx].dlyPlcCd
        this.subParam.cntrTyp = this.$props.parentInfo.items[idx].cntrTypCd

        this.mainIdx = idx
    },
    async subSelect () {
      return schedule.getMyCouponList(this.subParam).then(response => {
        const list = []
        this.list = [...list, ...response.data]

        // 이미 적용된 쿠폰번호가 있는지 확인
        const savedCouponNo = provider.getValue(this.mainIdx, 'couponNo')

        this.list = this.list.map(item => {
          if (savedCouponNo && item.couponNo === savedCouponNo) {
            return { ...item, applied: true }
          }
          return { ...item, applied: false }
        })

        this.list.sort((a, b) => {
          const benefitDiff = this.couponBenefit(b) - this.couponBenefit(a)
          if (benefitDiff !== 0) {
            return benefitDiff
          }
          const typeA = a.couponTyp || ''
          const typeB = b.couponTyp || ''
          if (typeA === '01' && typeB !== '01') {
            return -1
          }
          if (typeB === '01' && typeA !== '01') {
            return 1
          }
          const dateA = String(a.strDt || '')
          const dateB = String(b.strDt || '')
          return dateB.localeCompare(dateA)
        })

        provider2.setRows(this.list)
        // gridView2.orderBy(['couponTyp', 'strDt'], ['descending', 'descending'])
        gridView2.setCurrent({ itemIndex: 0 })
        return true
      }).catch(err => {
        console.log(err)
        return false
      })
    },
    async saveApplyCoupon () {
      let couponList = provider.getJsonRows(0, -1)
      let noCnt = 0
      for (let i = 0; i < couponList.length; i++) {
        if (typeof couponList[i].couponNo !== 'undefined') {
          noCnt = noCnt + 1
        }
      }

      if (noCnt > 0) {
        if (await this.$ekmtcCommon.asyncAlertMessage({ message: this.$t('msg.COUP100.055'), useConfirmBtn: true })) {
          let blArrStr = ''

          for (let i = 0; i < couponList.length; i++) {
            if (typeof couponList[i].couponNo !== 'undefined') {
              if (blArrStr !== '') {
                blArrStr += ','
              }
              blArrStr += couponList[i].blNo + '/' + couponList[i].couponNo
            }
          }

          let req = {
            blNo: blArrStr
          }

          await CalcIssue.couponApply(req).then(response => {
            console.log('Success')
            this.$emit('close', 'apply')
          }).catch(e => {
            console.log(e)
          })
        }
      } else {
        if (await this.$ekmtcCommon.asyncAlertMessage({ message: this.$t('msg.COUP100.054'), useConfirmBtn: true })) {
          this.$emit('close', 'apply')
        }
      }
    }
  }
}

</script>
